import type { AsyncAction } from "@reatom/async";
import { atom, type Fn } from "@reatom/framework";

export const withIsLoadingAtom: {
  <
    T extends AsyncAction & {
      isLoadingAtom?: ReturnType<typeof atom<boolean>>;
    },
  >(): Fn<[T], T & { isLoadingAtom: ReturnType<typeof atom<boolean>> }>;
} = () => (origin) => {
  const isLoadingAtom = atom(
    (ctx) => ctx.spy(origin.pendingAtom) > 0,
    `${origin.__reatom?.name || origin.name || "action"}IsLoadingAtom`,
  );

  return Object.assign(origin, { isLoadingAtom });
};
